// @ts-strict-ignore
import {Component, inject, input, Input, output} from "@angular/core";
import {FormControl} from "@angular/forms";
import {SimTimeService} from "../../../../../core/services/sim-services/sim-time.service";
import {NgxMaterialTimepickerTheme} from "ngx-material-timepicker";
import {DateTime} from "luxon";
import {Translations} from "@translations";

const lightTheme: NgxMaterialTimepickerTheme = {
	container: {buttonColor: "#279989"},
	dial: {dialBackgroundColor: "#279989", dialEditableActiveColor: "#279989"},
	clockFace: {clockHandColor: "#279989"},
};

const darkTheme: NgxMaterialTimepickerTheme = {
	container: {buttonColor: "#279989"},
	dial: {dialBackgroundColor: "#279989", dialEditableActiveColor: "#279989"},
	clockFace: {clockHandColor: "#279989"},
};

@Component({
	selector: "sim-clock-time-input",
	templateUrl: "./clock-time-input.component.html",
	styleUrl: "./clock-time-input.component.scss",
	standalone: false,
})
export class ClockTimeInputComponent {
	// I/O
	@Input({required: true}) formCtrl: FormControl<string>;
	@Input() theme: "light" | "dark" = "light";
	@Input() labelKey: string;
	onChange = output<string>();

	/**
	 * (optional) the minimum time that can be selected. Requires an ISO string
	 */
	public min = input<DateTime | null, string | null>(null, {
		transform: (timeString) => (!!timeString ? DateTime.fromISO(timeString) : null),
	});
	/**
	 * (optional) the maximum time that can be selected. Requires an ISO string
	 */
	public max = input<DateTime | null, string | null>(null, {
		transform: (timeString) => (!!timeString ? DateTime.fromISO(timeString) : null),
	});

	// Injections
	public timeService = inject(SimTimeService);

	// Readonly
	protected readonly T = Translations;
	protected readonly lightTheme = lightTheme;
	protected readonly darkTheme = darkTheme;

	public onTimeChanged(timeString: string) {
		this.formCtrl.setValue(timeString);
		this.onChange.emit(timeString);
	}
}
